import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('feedbackComment', 'feedbackComments');

const customActions = {
  async LOAD_feedbackComments({ commit, rootGetters }, feedbackItemId) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('feedbackComments')
      .query({
        $filter: `IsDeleted eq false AND FeedbackItemId eq ${feedbackItemId}`,
        $orderby: 'Created desc',
      });
    commit('SET_feedbackComments', data);
    return data;
  },
};

export default { ...actions, ...customActions };
